var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 503,
    viewBox: "0 0 380 503",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M369.552 100.238C368.371 63.2708 340.418 32.6838 303.706 28.1885L84.1155 1.29986C39.4127 -4.17396 0 30.7071 0 75.7439V418.384C0 458.661 31.8141 491.748 72.0611 493.326L302.028 502.344C345.515 504.05 381.318 468.505 379.928 425.007L369.552 100.238Z",
    fill: "#DFFFF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.63dc7b87ce1cb061e834f7b059f19bcc.svg";
export { ForwardRef as ReactComponent };